import { coreService } from "../../../services";
import {
  CustomShortVideoSuggestion,
  GenerateCustomShortFormVideoIdeasResponse,
  VideosResponse,
} from "../types";

const getVideos = async (
  episodeId: string | undefined,
): Promise<VideosResponse | undefined> => {
  if (episodeId) {
    const response = await coreService.httpClient.get(
      `/short-videos/episodes/${episodeId}`,
    );

    return response.data;
  }

  return undefined;
};

const generateCustomShortFormVideoIdeas = async (
  episodeId: string,
  prompt: string,
  allowAdditionalCharges?: boolean,
): Promise<GenerateCustomShortFormVideoIdeasResponse> => {
  const response = await coreService.httpClient.post(
    `short-videos/episodes/${episodeId}/custom`,
    {
      prompt,
      allow_additional_charges: allowAdditionalCharges || undefined,
    },
  );

  return response.data;
};

const saveCustomShortVideo = async (
  episodeId: string,
  customShortVideo: CustomShortVideoSuggestion,
): Promise<void> => {
  await coreService.httpClient.post(
    `short-videos/episodes/${episodeId}/custom/generate`,
    customShortVideo,
  );
};

export { getVideos, generateCustomShortFormVideoIdeas, saveCustomShortVideo };
